import editIcon from 'img/edit.svg'
import refreshBlueIcon from 'img/refresh-blue.svg'
import thumbsDownIcon from 'img/thumbs-down.svg'
import thumbsDownDisabled from 'img/thumbs-down-disabled.svg'
import thumbsUpDisabled from 'img/thumbs-up-disabled.svg'
import thumbsUpIcon from 'img/thumbs-up.svg'
import { memo, useRef, useState, useEffect } from 'react'
import { ThumbsDownTooltip } from 'lesson-builder/components/tooltips/thumbs-down-tooltip'
import { RefreshTooltip } from 'lesson-builder/components/tooltips/refresh-tooltip'

/**
 * @module lesson-builder/components/view-action-row
 * @description The thumbs-up/thumbs-down/refresh/edit icon row shown
 * under a question in view mode. See
 * docs/BLUEPRINT-2026-10-01-question-slide-decomposition.md.
 */
export const ViewActionRow = memo(({ isApproved, isDisapproved, handleApprove, setIsEditing, setShowFeedback, canEdit }: { isApproved: boolean, isDisapproved: boolean, handleApprove: ( boolean ) => void, setIsEditing: (isEditing: boolean) => void, setShowFeedback: (showFeedback: boolean) => void, canEdit?: boolean }) => {
	const [showThumbsDownTooltip, setShowThumbsDownTooltip] = useState(false)
	const [showRefreshTooltip, setShowRefreshTooltip] = useState(false)
	const thumbsDownRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (!showThumbsDownTooltip) return
		const handleClickOutside = (e: MouseEvent) => {
			if (thumbsDownRef.current && !thumbsDownRef.current.contains(e.target as Node)) {
				setShowThumbsDownTooltip(false)
			}
		}
		document.addEventListener('mousedown', handleClickOutside)
		return () => document.removeEventListener('mousedown', handleClickOutside)
	}, [showThumbsDownTooltip])

	return (
		<div className="view-actions-row">
			<div className="view-action-icon-container">
				<img
					src={canEdit === false || isApproved ? thumbsUpDisabled : thumbsUpIcon}
					alt="thumbs up"
					className="view-action-icon"
					onClick={canEdit !== false ? () => handleApprove(true) : undefined}
				/>
			</div>
			<div className="view-action-icon-container" ref={thumbsDownRef}>
				<img
					src={canEdit === false || isDisapproved ? thumbsDownDisabled : thumbsDownIcon}
					alt="thumbs down"
					className="view-action-icon"
					onClick={canEdit !== false ? () => {setShowThumbsDownTooltip(!showThumbsDownTooltip); handleApprove(false);} : undefined} />
				{showThumbsDownTooltip && <ThumbsDownTooltip />}
			</div>
			{canEdit !== false && (
				<div className="view-action-icon-container">
					<img
						src={refreshBlueIcon}
						alt="refresh"
						className="view-action-icon"
						onMouseOver={() => setShowRefreshTooltip(true)}
						onMouseOut={() => setShowRefreshTooltip(false)}
						onClick={() => setShowFeedback(true)}
					/>
					{showRefreshTooltip && <RefreshTooltip />}
				</div>
			)}
			{canEdit !== false && (
				<img
					src={editIcon}
					alt="edit"
					className="view-action-icon"
					onClick={() => setIsEditing(true)}
				/>
			)}
		</div>
	)
})

export default ViewActionRow
